import type { AddonInstallation, Catalog } from './index.ts';

export const CINEMETA_ID = 'builtin-cinemeta';
// Explicit read-only subset of Cinemeta3.0.14, reviewed2026-09-08. No stream,
// community-addon listing or arbitrary upstream URL is part of this contract.
export function cinemeta(year = new Date().getUTCFullYear()): AddonInstallation {
  const genres = ['Action', 'Adventure', 'Animation', 'Biography', 'Comedy', 'Crime', 'Documentary', 'Drama', 'Family',
    'Fantasy', 'History', 'Horror', 'Mystery', 'Romance', 'Sci-Fi', 'Short', 'Sport', 'Thriller', 'War', 'Western'];
  // Cinemeta's own metadata links to Short although 3.0.14 omits it from
  // options. All four top/rating endpoints verified on 2026-09-21; other
  // undeclared values and installed-addon manifests keep their normal checks.
  const catalogs: Catalog[] = ['movie', 'series'].flatMap(type => {
    const options = type === 'movie' ? genres : [...genres, 'Reality-TV', 'Talk-Show', 'Game-Show'];
    const years = Array.from({ length: Math.max(1, year - (type === 'movie' ? 1920 : 1960) + 1) }, (_, n) => String(year - n));
    return [
      { id: 'top', type, name: 'Popular', extra: [{ name: 'genre', options }, { name: 'search' }, { name: 'skip' }] },
      { id: 'year', type, name: 'New', extra: [{ name: 'genre', options: years, isRequired: true }, { name: 'skip' }] },
      { id: 'imdbRating', type, name: 'Featured', extra: [{ name: 'genre', options }, { name: 'skip' }] },
    ];
  });
  return { id: CINEMETA_ID, builtin: true, enabled: true, position: -1, manifest: {
    id: 'com.linvo.cinemeta', name: 'Cinemeta', version: '3.0.14', types: ['movie', 'series'], idPrefixes: ['tt'],
    resources: ['catalog', 'meta'], catalogs,
  } };
}
